/**
 * @generated SignedSource<<def26930d790177e6d95b5fee00bb8b1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type JiraAssigneeSelectionType = "ACCOUNT_OWNER" | "ACCOUNT_TAG" | "ACCOUNT_VARIABLE" | "EMAIL" | "RESOURCE_OWNER" | "RESOURCE_TAG" | "%future added value";
export type JiraSpaceSelectionType = "ACCOUNT_TAG" | "ACCOUNT_VARIABLE" | "RESOURCE_TAG" | "SPACE_KEY" | "%future added value";
export type NotificationRulePreviewInput = {
  filter: FilterElementInput;
  groupBy: ReadonlyArray<string>;
  includeCostData: boolean;
  jiraTarget?: NotificationRuleJiraTargetInput | null | undefined;
  numberOfGroups?: number;
};
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  qualifier?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type NotificationRuleJiraTargetInput = {
  assignee?: JiraAssigneeSelectionInput | null | undefined;
  description?: string | null | undefined;
  instanceUUID: any;
  space: JiraSpaceSelectionInput;
  workType: string;
};
export type JiraSpaceSelectionInput = {
  type: JiraSpaceSelectionType;
  value: string;
};
export type JiraAssigneeSelectionInput = {
  type: JiraAssigneeSelectionType;
  value?: string | null | undefined;
};
export type useNotificationRulePreviewQuery$variables = {
  input: NotificationRulePreviewInput;
};
export type useNotificationRulePreviewQuery$data = {
  readonly notificationRulePreview: {
    readonly groups: ReadonlyArray<{
      readonly assignee?: string | null | undefined;
      readonly issueTitle?: string;
      readonly mostRecentMatch?: string;
      readonly policy?: {
        readonly name: string;
        readonly uuid: any;
      };
      readonly resourceCount?: number;
      readonly spaceKey?: string;
    }> | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly samplePreview: {
      readonly adfDocument?: string;
    } | null | undefined;
    readonly totalGroupCount: number | null | undefined;
  } | null | undefined;
};
export type useNotificationRulePreviewQuery = {
  response: useNotificationRulePreviewQuery$data;
  variables: useNotificationRulePreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignee",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueTitle",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mostRecentMatch",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourceCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spaceKey",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adfDocument",
      "storageKey": null
    }
  ],
  "type": "NotificationRuleJiraPreviewSample",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalGroupCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useNotificationRulePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "NotificationRulePreviewPayload",
        "kind": "LinkedField",
        "name": "notificationRulePreview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Policy",
                    "kind": "LinkedField",
                    "name": "policy",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "type": "NotificationRuleJiraPreviewGroup",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v9/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "samplePreview",
            "plural": false,
            "selections": [
              (v10/*:: as any*/)
            ],
            "storageKey": null
          },
          (v11/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useNotificationRulePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "NotificationRulePreviewPayload",
        "kind": "LinkedField",
        "name": "notificationRulePreview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              (v12/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Policy",
                    "kind": "LinkedField",
                    "name": "policy",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "type": "NotificationRuleJiraPreviewGroup",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v12/*:: as any*/),
              (v9/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "samplePreview",
            "plural": false,
            "selections": [
              (v12/*:: as any*/),
              (v10/*:: as any*/)
            ],
            "storageKey": null
          },
          (v11/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19fb4170cba0842a099daec8c0a88a15",
    "id": null,
    "metadata": {},
    "name": "useNotificationRulePreviewQuery",
    "operationKind": "query",
    "text": "query useNotificationRulePreviewQuery(\n  $input: NotificationRulePreviewInput!\n) {\n  notificationRulePreview(input: $input) {\n    groups {\n      __typename\n      ... on NotificationRuleJiraPreviewGroup {\n        assignee\n        issueTitle\n        mostRecentMatch\n        policy {\n          name\n          uuid\n          id\n        }\n        resourceCount\n        spaceKey\n      }\n    }\n    problems {\n      __typename\n      message\n    }\n    samplePreview {\n      __typename\n      ... on NotificationRuleJiraPreviewSample {\n        adfDocument\n      }\n    }\n    totalGroupCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "8548a4edbc9c36241e36f7b37e1a1034";

export default node;
